import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {useFormik} from "formik";
import {loginWithPassword, setToken} from "../../services";
import {initialValues, validationSchema} from "../../utils/formsValidator/loginWithPasswordFormValidator";
import {useAuthAction} from "../../context/AuthContext";
import {pushToast} from "../../utils/pushToast";
import Loading from "../../components/Loading";
import Input from "../../components/Input";
import InputPassword from "../../components/InputPassword";

export default function Login2() {
    const navigate = useNavigate();
    const setAuth = useAuthAction();
    const [isLoading, setIsLoading] = useState(false);

    const onSubmit = async (values) => {
        setIsLoading(true);
        try {
            const {userInfo, userPermission} = await loginWithPassword(values);
            if (userInfo?.isSuccess) {
                setToken(userInfo?.data?.token);
                setAuth({userInfo: userInfo?.data, userPermission});

                if (userInfo?.data?.requiredChangePassword) {
                    navigate('/change-password');
                } else {
                    navigate('/dashboard');
                }
            } else {
                pushToast("شماره موبایل یا رمز عبور اشتباه است.", "error");
            }
        } catch (error) {
            console.log(error);
            pushToast("شماره موبایل یا رمز عبور اشتباه است.", "error");
        } finally {
            setIsLoading(false);
        }
    };

    const formik = useFormik({initialValues, onSubmit, validationSchema, validateOnChange: true});

    return (
        <div className="container-xxl">
            <div className="authentication-wrapper authentication-basic container-p-y">
                <div className="authentication-inner py-4">
                    <div className="card">
                        <div className="card-body">
                            <div className="app-brand justify-content-center">
                                <img src="/logo.png" className="w-100" alt="Logo"/>
                            </div>
                            <h4 className="mb-2">اطلاعات کاربری خود را وارد نمایید.</h4>
                            <form className={`needs-validation mb-3 ${!formik.isValid ? "was-validated" : ""}`}
                                  noValidate onSubmit={formik.handleSubmit} autoComplete="off">
                                <div className="mb-3 position-relative">
                                    <Input type="text" inputMode="tel" className="text-start" dir="ltr"
                                           name="mobile" placeholder="شماره موبایل خود را وارد کنید"
                                           autoComplete="username" label="شماره موبایل" formik={formik}/>
                                </div>
                                <div className="mb-3 form-password-toggle">
                                    <InputPassword className="text-start" dir="ltr" name="password"
                                                   placeholder="..........." autoComplete="current-password"
                                                   formik={formik} label="رمز عبور"/>
                                </div>
                                <button className="btn btn-primary d-grid w-100" type="submit" disabled={isLoading}>
                                    ورود {isLoading && <Loading/>}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
